import { apolloClient } from "@/plugins/apollo";
import gql from "fraql";
import { computed, ref } from "vue";
import { sortByRank, returnActiveItems } from "../factory";
export const MasterQualificationFragment = gql `
  fragment _ on Qualification {
    id
    name
    status
    qualificationGroupId
    disciplineId
    category
    rank
  }
`;
export function useQualificationHelper() {
    const masterQualificationsLoading = ref(true);
    const masterQualifications = ref([]);
    const masterQualificationsActive = computed(() => returnActiveItems(masterQualifications.value));
    apolloClient
        .query({
        query: gql `
        query MasterQualifications {
          qualifications {
            ${MasterQualificationFragment}
          }
        }
      `,
        fetchPolicy: "cache-first"
    })
        .then(({ data }) => {
        var _a;
        masterQualificationsLoading.value = false;
        masterQualifications.value = sortByRank((_a = data === null || data === void 0 ? void 0 : data.qualifications) !== null && _a !== void 0 ? _a : []);
    });
    return {
        masterQualificationsLoading,
        masterQualifications,
        masterQualificationsActive
    };
}
